"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Initiate() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.3
  });
  const {
    ref: bodyRef,
    isVisible: bodyVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: detailsRef,
    isVisible: detailsVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const headlineWords = ["Bereit", "für", "den", "nächsten", "digitalen"];
  const italicWord = "Erfolg?";
  return <section data-section-id="2776" id="bereit-für-den-nächsten-schritt" className="bg-background text-foreground min-h-[80vh] flex flex-col justify-center py-24 md:py-32 px-6 md:px-10 lg:px-16 relative overflow-hidden">
      <div className="max-w-[1400px] mx-auto w-full grid grid-cols-12 gap-6">
        {}
        <div ref={bodyRef} className="col-span-12 md:col-start-2 md:col-span-7 flex items-center gap-4 mb-16 md:mb-24">
          <div className="h-px flex-1 bg-border" />
          <span className={`font-mono text-[10px] md:text-xs uppercase tracking-[0.3em] text-muted-foreground whitespace-nowrap transition-all duration-700 ${bodyVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2"}`}>
            <span className="text-primary mr-2">/ 04</span>
            Kontakt
          </span>
          <div className="h-px flex-1 bg-border" />
        </div>

        {}
        <div className="col-span-12 md:col-start-2 md:col-span-7">
          <h2 ref={headlineRef} className="font-default font-light leading-[1.02] tracking-tight text-foreground" style={{
          fontSize: "clamp(2.75rem, 8vw, 7rem)"
        }}>
            <span className="block">
              {headlineWords.slice(0, 3).map((word, i) => <span key={i} data-index={i} className="inline-block overflow-hidden align-bottom mr-[0.25em]">
                  <span className={`inline-block transition-transform duration-700 ease-out ${headlineVisible ? "translate-y-0" : "translate-y-full"}`} style={{
                transitionDelay: `${i * 80}ms`
              }}>
                    {word}
                  </span>
                </span>)}
            </span>
            <span className="block">
              {headlineWords.slice(3).map((word, i) => <span key={i + 3} data-index={i + 3} className="inline-block overflow-hidden align-bottom mr-[0.25em]">
                  <span className={`inline-block transition-transform duration-700 ease-out ${headlineVisible ? "translate-y-0" : "translate-y-full"}`} style={{
                transitionDelay: `${(i + 3) * 80}ms`
              }}>
                    {word}
                  </span>
                </span>)}
              <span className="inline-block overflow-hidden align-bottom">
                <span className={`inline-block italic text-primary transition-transform duration-700 ease-out ${headlineVisible ? "translate-y-0" : "translate-y-full"}`} style={{
                transitionDelay: `${headlineWords.length * 80}ms`
              }}>
                  {italicWord}
                </span>
              </span>
            </span>
          </h2>

          {}
          <p className={`mt-10 md:mt-14 max-w-xl text-base md:text-lg leading-relaxed font-default text-muted-foreground transition-all duration-700 delay-500 ${headlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            Lassen Sie uns gemeinsam Ihr Projekt in Oldenburg realisieren. Wir melden uns innerhalb von 24 Stunden bei Ihnen.
          </p>

          {}
          <div className={`mt-10 md:mt-12 flex flex-col sm:flex-row items-start sm:items-center gap-6 sm:gap-8 transition-all duration-700 delay-700 ${headlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <Button asChild size="lg" className="rounded-lg px-8 py-6 bg-primary text-primary-foreground hover:bg-primary/90 shadow-md font-default text-sm tracking-wide">
              <Link to="/ContactPage">Jetzt kostenlose Ersteinschätzung anfragen</Link>
            </Button>
            <Link to="/ContactPage" className="group inline-flex items-center font-default text-sm tracking-wide text-foreground">
              <span className="border-b border-foreground/40 pb-1 group-hover:border-foreground transition-colors">
                Direkt Kontakt aufnehmen
              </span>
            </Link>
          </div>
        </div>

        {}
        <div ref={detailsRef} className="col-span-12 md:col-start-10 md:col-span-3 flex md:items-center mt-12 md:mt-0">
          <div className="w-full">
            <div className="h-px bg-border w-full mb-6" />
            <div className="space-y-5 font-mono text-[11px] uppercase tracking-[0.2em] text-muted-foreground">
              {[{
              label: "Standort",
              value: "Oldenburg, DE"
            }, {
              label: "Telefon",
              value: "+49 441 ••• •••"
            }, {
              label: "E-Mail",
              value: "Jerome@orvoweb.de"
            }].map((item, i) => <div key={i} data-index={i} className={`transition-all duration-700 ${detailsVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-3"}`} style={{
              transitionDelay: `${i * 120}ms`
            }}>
                  <div className="text-primary/80 text-[9px] mb-1.5">{item.label}</div>
                  <div className="text-foreground/90 normal-case tracking-wide">
                    {item.value}
                  </div>
                  {i < 2 && <div className="h-px bg-border w-full mt-5" />}
                </div>)}
            </div>
            <div className="h-px bg-border w-full mt-5" />
          </div>
        </div>
      </div>
    </section>;
}